import { SelectOption } from '@vchasno/ui-kit';

import {
  DocumentActionType,
  HrsDocumentCategory,
  TaskDocumentAccessSettings,
} from 'api/api';

export enum UniversalDocumentStep {
  INITIATOR = 'initiator',
  DOCUMENTS = 'documents',
  SETTINGS = 'settings',
}

export enum UniversalDocumentProcess {
  CREATE = 'create',
  EDIT = 'edit',
}

export enum UniversalDocumentSettingsSection {
  FILE = 'file',
  SIGNERS = 'signers',
  ACCESS_SETTINGS = 'accessSettings',
}

export interface UniversalDocumentFile {
  name: string;
  number: Nullable<string>;
  category: Nullable<HrsDocumentCategory>;
}

export interface UniversalDocumentSigner {
  fullName: string;
  id: string;
  position: Nullable<string>;
  actionType: DocumentActionType;
  deletable: boolean;
}

export interface UniversalDocument {
  id: string;
  routeId: string;
  file: UniversalDocumentFile;
  signers: UniversalDocumentSigner[];
  isParallel: boolean;
  accessSettings: TaskDocumentAccessSettings;
}

export interface UniversalDocumentState {
  process: UniversalDocumentProcess;
  step: UniversalDocumentStep;
  allowedSteps: UniversalDocumentStep[];
  initiator: Nullable<SelectOption>;
  company: Nullable<SelectOption>;
  taskId: Nullable<string>;
  isUniqueDocumentSettings: boolean;
  documents: Record<string, UniversalDocument>;
  activeDocumentId: Nullable<string>;
  allowedDocumentSections: UniversalDocumentSettingsSection[];
  activeDocumentSection: Nullable<UniversalDocumentSettingsSection>;
}
